import { render, staticRenderFns } from "./More.vue?vue&type=template&id=e46a893a&scoped=true&"
var script = {}
import style0 from "./More.vue?vue&type=style&index=0&id=e46a893a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46a893a",
  null
  
)

export default component.exports